export enum OrganizationFlag {
  WorldDryer = 'WD',
  Hadrian = 'HAD',
}
